// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3i0-l","inner":"Footer_inner__3-Dec","nextIcon":"Footer_nextIcon__3Rtuh","innerLeft":"Footer_innerLeft__3gYin"};